module.exports = __webpack_public_path__ + "img/AddNote.3df63812.svg";